// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"_1kcd6"};